export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
    // Register anyway; most modern browsers accept https-only, this fails silently otherwise
  }
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {
      // Silent fail: PWA is progressive enhancement
    });
  });
}
